import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ConfirmationPromptPayload } from '../../../model';
import {MatIcon} from "@angular/material/icon";

@Component({
  selector: 'app-confirmation-prompt',
  templateUrl: './confirmation-prompt.component.html',
  styleUrls: ['./confirmation-prompt.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogModule, MatIcon],
})
export class ConfirmationPromptComponent {
  data = inject<ConfirmationPromptPayload>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject<MatDialogRef<ConfirmationPromptComponent>>(MatDialogRef);

  onConfirmationClick(): void {
    this.dialogRef.close('accept');
  }

  onCloseClick(isRejected: boolean): void {
    this.dialogRef.close(isRejected ? 'reject' : 'close');
  }
}
